import { gql } from './generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
export default gql(`
  mutation createPost(
    $title: String
    $topicId: ID
    $libraryName: String
    $source: String
    $type: PostType
  ) {
    post: createPost(
      title: $title
      topicId: $topicId
      libraryName: $libraryName
      source: $source
      type: $type
    ) {
      id
      publishedAt
      title
      ...AllSlimPostFields
      topics {
        ...TopicFields
      }
    }
  }
`);
